function removeAlpha(hexString) {
  // Check if the input is a valid hex string
  if (!/^#[0-9A-Fa-f]{8}$/.test(hexString)) {
    return hexString;
  }

  // Remove the alpha channel (last two characters) from the hex string to get RGB format
  const hexWithoutAlpha = hexString.slice(0, 7);

  return hexWithoutAlpha;
}

export { removeAlpha };
